import React from 'react';
import CaseStudies from '../../components/CaseStudies/CaseStudies';
import './CaseStudies.css';

const CaseStudiesPage = () => {
    return (
        <div className="case-studies-page">
            <CaseStudies />
        </div>
    );
};

export default CaseStudiesPage;

